import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getMediaSize } from 'components/chat/details/Conversation/SendBox/utils';
import { MEDIA_TYPE } from 'constants/MediaConstants';
import { isEmpty } from 'utils/global';
import { createDictionary } from 'utils/ObjectUtils';

import { getContentType } from './getContentType';

const mediaDurationValidator = (media, config) => {
  const duration = media.file?.time ?? media.media?.time;
  const maxDuration = config['max-length'];

  if (maxDuration && (!duration || duration > maxDuration)) {
    return (<FormattedMessage
      id="mediaValidation.errors.duration"
      defaultMessage="This media exceeds the allowed duration ({maxDuration} seconds)"
      values={{ maxDuration }}
    />);
  }
  return undefined;
};

const mediaContentTypeValidator = (media, config) => {
  const contentType = getContentType(media);
  const contentTypeAuthorized = config['supported-types'];

  if (contentTypeAuthorized && !contentTypeAuthorized.includes(contentType)) {
    return (<FormattedMessage
      id="mediaValidation.errors.extension"
      defaultMessage="This media is an unsupported extension"
    />);
  }
  return undefined;
};

const MB_IN_BYTES = 1024 * 1024;

const mediaSizeValidator = (media, config) => {
  const fileSize = media.file?.size ?? getMediaSize(media.media ?? {});
  const maxFileSize = config['max-file-size'];
  const maxFileSizeInBytes = maxFileSize * MB_IN_BYTES;

  if (maxFileSize && (!fileSize || fileSize > maxFileSizeInBytes)) {
    return (<FormattedMessage
      id="mediaValidation.errors.fileSize"
      defaultMessage="This media exceeds the authorized size ({maxFileSize} MB)"
      values={{ maxFileSize }}
    />);
  }

  return undefined;
};

const TYPE_VALIDATOR = createDictionary({
  [MEDIA_TYPE.VIDEO]: mediaDurationValidator,
}, () => undefined);

export const computeMediaErrors = (medias, config) => {
  const errors = medias.reduce((acc, media) => {
    const mediaType = (media.mediaType ?? media.media?.type ?? '');
    const configByMediaType = config[mediaType.toLowerCase()];

    if (!configByMediaType) {
      return undefined;
    }

    const errorMessage =
      mediaContentTypeValidator(media, configByMediaType) ??
      mediaSizeValidator(media, configByMediaType) ??
      TYPE_VALIDATOR[mediaType.toUpperCase()](media, configByMediaType);

    if (errorMessage) {
      return {
        ...acc,
        [media.id]: errorMessage,
      };
    }
    return acc;
  }, {});

  return isEmpty(errors) ? undefined : errors;
};
